/**
 * GET /task-types?relations[0]=author&relations[2]=status&relations[3]=parent
 */
export const TASK_TYPE_RELATIONS = {
  'relations[0]': 'author',
  'relations[2]': 'status',
  'relations[3]': 'parent',
};

export const buildTaskTypeRelationParams = () => ({ ...TASK_TYPE_RELATIONS });
